<template>
  <v-container grid-list-md fluid>
    <vue-headful :title="pageTitle"/>
    <v-layout grid-list-md wrap>
      <v-flex d-flex xs4>
        <v-card>
          <v-card-text class="text-xs-center d-flex fill-height">
            <v-layout column justify-center>
              <h2>Группа: {{group.name}}</h2>
              <p>Дата аттестации: {{ group.attestationInfo.date }}</p>
              <p>Статус аттестации: {{ group.attestationInfo.status }}</p>
              <p>
                <v-btn v-if="attestationInfoReadyToStart" color="success" @click="startAttestation">
                  Начать аттестацию
                </v-btn>
                <v-btn v-if="attestationInfoReadyToEnd" color="success" @click="endAttestation">
                  Закончить аттестацию
                </v-btn>
              </p>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex d-flex xs8>
        <v-card>
          <v-card-text>
            <p>Всего аттестуемых: {{ group.students.length }}</p>
            <p>В процессе: {{ counter.inProcess }}</p>
            <p>Аттестовано: {{ counter.attested }}</p>
            <p>Не аттестовано: {{ counter.notAttested }}</p>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <v-card>
          <v-card-text>
            <DataTable :headers="headers" :items="group.students" class="table">
              <tr slot-scope="props">
                <td class="text-xs-center">{{ props.index +1 }}</td>
                <td>{{ props.item.uin }}</td>
                <td class="text-xs-center">{{ props.item.status }}</td>
                <td class="justify-center layout px-0 mx-0">
                  <v-btn flat icon :disabled="['Не аттестован', 'Аттестован'].indexOf(props.item.status) === -1"
                         :to="{name: 'AdminAttestationInfoStudentView', params: {id: props.item.id.toString()}}">
                    <v-icon small>visibility</v-icon>
                  </v-btn>
                  <v-btn flat icon :disabled="['Не аттестован', 'Аттестован'].indexOf(props.item.status) === -1"
                         @click="toPdf(props.item.id)">
                    <v-icon small>print</v-icon>
                  </v-btn>
                </td>
              </tr>
            </DataTable>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import GroupView from '@/pages/admin/group/View'
import DataTable from '@/components/fragments/DataTable'
import AttestationInfoService from '@/services/AttestationInfoService'
import AttestationService from '@/services/AttestationService'
import SettingsService from '@/services/SettingsService'

export default {
  props: {
    id: String
  },
  data: () => ({
    headers: [
      {text: '№', align: 'center', sortable: false, width: 50},
      {text: 'УИН', align: 'left', sortable: false},
      {text: 'Статус', align: 'center', sortable: false, width: 200},
      {text: 'Действия', align: 'center', sortable: false, width: 100}
    ],
    attestationInfo: AttestationInfoService.getDefaultAttestationInfo(),
    attestationInfoService: undefined,
    attestationService: undefined
  }),
  created () {
    this.attestationService = new AttestationService(this.$store)
    this.attestationInfoService = new AttestationInfoService(this.$store)
    this.getAttestationInfo()
  },
  computed: {
    group () {
      return this.attestationInfo.group
    },
    counter () {
      return this.attestationInfo.counter
    },
    pageTitle () {
      return SettingsService.pageTitle('Информация об аттестации группы "' + this.group.name + '"')
    },
    attestationInfoReadyToStart () {
      return ['В процессе', 'Закончена'].indexOf(this.group.attestationInfo.status) === -1 && this.group.attestationInfo.date === formatDate(new Date())
    },
    attestationInfoReadyToEnd () {
      return this.group.attestationInfo.status === 'В процессе'
    }
  },
  methods: {
    startAttestation () {
      this.attestationService.startAttestation(this.id, (data) => {
        if (data.status) {
          this.getAttestationInfo()
        }
      })
    },
    endAttestation () {
      this.attestationService.endAttestation(this.id, (data) => {
        if (data.status) {
          this.getAttestationInfo()
        }
      })
    },
    getAttestationInfo () {
      this.attestationInfoService.getAttestationInfo(this.id, (data) => {
        this.attestationInfo = data
      })
    },
    toPdf (id) {
      this.attestationService.resultToPdf(id, blob => {
        this.fileUrl = URL.createObjectURL(blob)
        window.open(process.env.SITE_URL + '/pdf/view?link=' + this.fileUrl)
        window.focus()
      })
    }
  },
  components: {DataTable, GroupView}
}

function formatDate (date) {
  let dd = date.getDate()
  if (dd < 10) dd = '0' + dd
  let mm = date.getMonth() + 1
  if (mm < 10) mm = '0' + mm
  let yy = date.getFullYear()
  return dd + '.' + mm + '.' + yy
}
</script>

<style scoped>
  .table {
    box-shadow: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/admin/attesation_info/Index.vue